module.exports = __webpack_public_path__ + "signip-bg.df6076f775ed2bd8f750.jpg";


//////////////////
// WEBPACK FOOTER
// /revet-web/src/assets/images/signip-bg.jpg
// module id = ../../../../../src/assets/images/signip-bg.jpg
// module chunks = styles